var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.normalizedValue),function(v,index){return _c('span',{key:v,staticClass:"enum-item"},[(index > 0)?[_vm._v("| ")]:_vm._e(),_vm._v(_vm._s(v)+"\n    ")],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }